import { render, staticRenderFns } from "./SoyReferee.vue?vue&type=template&id=6740068c&scoped=true&"
import script from "./SoyReferee.vue?vue&type=script&lang=js&"
export * from "./SoyReferee.vue?vue&type=script&lang=js&"
import style0 from "./SoyReferee.vue?vue&type=style&index=0&id=6740068c&prod&scoped=true&lang=scss&"
import style1 from "./SoyReferee.vue?vue&type=style&index=1&id=6740068c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6740068c",
  null
  
)

export default component.exports